// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Pipe, PipeTransform } from '@angular/core';
import { InternalDocumentType } from '@interfaces/document.interfaces';

@Pipe({
    name: 'activeInternalDocument',
})
export class ActiveInternalDocumentPipe implements PipeTransform {
    transform(items: InternalDocumentType[]): InternalDocumentType[] {
        if (!items) return [];
        return items.filter((item) => item.active);
    }
}
